export default {"src":"/_next/static/media/battery.9344916f.svg","height":25,"width":25};